import React, { createContext, ReactNode, useContext, useState } from 'react';
import ClockOffLabourModal from '../components/clockOffLabourModal/ClockOffLabourModal';
import { IRepairOrder } from '../models/dms/repairOrder.model';
import { IRepairOrderJob } from '../models/dms/repairOrderJob.model';

interface IComponentProps {
  children: ReactNode;
}

const ClockOffLabourModalProvider: React.FC<IComponentProps> = function ({ children }) {
  /*
  ** State can be exposed through the private API
  */
  const [showModal, setShowModal] = useState<boolean>(false);
  const [job, setJob] = useState<IRepairOrderJob>({} as IRepairOrderJob);
  const [repairOrder, setRepairOrder] = useState<IRepairOrder>({} as IRepairOrder);
  const [clockOffAttendance, setClockOffAttendance] = useState<boolean | undefined>();
  const [attendanceEndDateTime, setAttendanceEndDateTime] = useState<Date | undefined>();
  const [handleDismiss, setHandleDismiss] = useState<() => void | undefined>();

  /*
  ** This method can be exposed through the private API but can only contain
  ** react specific code
  */
  const showClockOffLabourModal = (job: IRepairOrderJob, repairOrder: IRepairOrder, clockOffAttendance?: boolean, attendanceEndDateTime?: Date, handleDismiss?: () => void) => {
    setShowModal(true);
    setJob(job);
    setRepairOrder(repairOrder);
    setClockOffAttendance(clockOffAttendance);
    setAttendanceEndDateTime(attendanceEndDateTime);
    setHandleDismiss(() => handleDismiss);
  };

  const hideClockOffLabourModal = () => {
    setShowModal(false);
  };

  return (
    <ClockOffLabourModalContext.Provider value={
      {
        state: {},
        actions: {
          showClockOffLabourModal,
          hideClockOffLabourModal,
        }
      }
    }>
      {children}
      <ClockOffLabourModal showModal={showModal} jobData={job} repairOrder={repairOrder} handleDismiss={() => { setShowModal(false); handleDismiss && handleDismiss(); }} clockOffAttendance={clockOffAttendance} attendanceEndDateTime={attendanceEndDateTime} />
    </ClockOffLabourModalContext.Provider>
  );
};

export const clockOffLabourModalProvider = {
  state: {} as {},
  actions: {} as {
    showClockOffLabourModal: (job: IRepairOrderJob, repairOrder: IRepairOrder, clockOffAttendance?: boolean, attendanceEndDateTime?: Date, handleDismiss?: () => void) => void,
    hideClockOffLabourModal: () => void,
  }
};

/*
** NOTE:
** To use this in react components, use the following code example:
** const { state: {showClockOffModal}, actions: { privateMethod, setShowClockOffModal }} = useClockOffLabourModal();
**
** To use this in non-react components, use the following code example:
** clockOffLabourModalStatic.publicMethod();
*/

export const ClockOffLabourModalContext = createContext<typeof clockOffLabourModalProvider>(clockOffLabourModalProvider);
export const useClockOffLabourModal = () => useContext(ClockOffLabourModalContext);

// Expose methods for use in non-react components
export const clockOffLabourModalStatic = {};

export default ClockOffLabourModalProvider;
